<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> RELATÓRIO DE ROYALTIES </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="typeCompany"
                :items="types"
                label="Tipo de Empresa"
                outlined
                hide-details
                multiple
                class="mt-1"
                dense
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggle">
                    <v-list-item-action>
                      <v-icon
                        :color="typeCompany.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectTypes }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="status"
                :items="statusCompany"
                class="mt-1"
                label="Status"
                outlined
                dense
                hide-details
              >
              </v-select>
              <!-- <v-switch
                v-model="status"
                class="mt-4"
                label="Mostrar Inativas"
                :false-value="0"
                :true-value="1"
              ></v-switch> -->
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="selectedRegions"
                :items="regions"
                label="Região"
                outlined
                hide-details
                multiple
                item-text="description"
                item-value="name"
                class="mt-1"
                dense
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleRegion">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          selectedRegions.length > 0 ? 'indigo darken-4' : ''
                        "
                      >
                        {{ iconSelectedRegion }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="selectedRegions.length === 1">{{
                    item.description
                  }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ selectedRegions.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                v-model="selectedUfs"
                :items="ufs"
                label="UF"
                outlined
                hide-details
                multiple
                :item-text="(item) => `${item.value} - ${item.description}`"
                item-value="value"
                class="mt-1"
                dense
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple @mousedown.prevent @click="toggleUfs">
                    <v-list-item-action>
                      <v-icon
                        :color="selectedUfs.length > 0 ? 'indigo darken-4' : ''"
                      >
                        {{ iconSelectedUf }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title> Todos </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:selection="{ index, item }">
                  <span v-if="selectedUfs.length === 1">{{
                    `${item.value} - ${item.description}`
                  }}</span>
                  <span v-if="index === 1" class="black--text">
                    {{ selectedUfs.length }} selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-2"
                @click="getLogs()"
              >
                Executar Consulta
              </v-btn>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-btn
                :disabled="logs.length == 0"
                @click="exportLogs('excel')"
                color="grey darken-4"
                outlined
                small
                class="mt-4 float-right"
              >
                <v-icon color="green" left> mdi-file-excel-box </v-icon>
                Excel
              </v-btn>
              <v-btn
                :disabled="logs.length == 0"
                @click="exportLogs('pdf')"
                color="grey darken-4"
                outlined
                small
                class="mt-4 mr-1 float-right"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap">
                                Código
                              </th>
                              <th class="text-left fs-12 text-no-wrap">Nome</th>
                              <th class="text-left fs-12 text-no-wrap">
                                Função
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Status
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                CPF/CNPJ
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Inscrição Estadual
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Cidade
                              </th>
                              <th class="text-left fs-12 text-no-wrap">UF</th>
                              <th class="text-right fs-12 text-no-wrap">
                                Inicio Acordo
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Final Acordo
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Royalties(%)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="log in logs" :key="log.id">
                              <td>
                                {{ log.code }}
                              </td>
                              <td>
                                {{ log.name }}
                              </td>
                              <td>
                                {{
                                  log.type === "fra"
                                    ? "Franquia"
                                    : "Multimarcas"
                                }}
                              </td>
                              <td>
                                {{ log.status == "1" ? "Ativo" : "Inativo" }}
                              </td>
                              <td>
                                {{ log.document }}
                              </td>
                              <td>
                                {{ log.state_registration }}
                              </td>
                              <td>
                                {{
                                  `${
                                    log.delivery_city == null
                                      ? ""
                                      : log.delivery_city
                                  }`
                                }}
                              </td>
                              <td>
                                {{
                                  `${
                                    log.delivery_state == null
                                      ? ""
                                      : log.delivery_state
                                  }`
                                }}
                              </td>
                              <td class="text-right">
                                {{ log.start_date | dateFormatBr }}
                              </td>
                              <td class="text-right">
                                {{ log.end_date | dateFormatBr }}
                              </td>
                              <td class="text-right">{{ log.royalties }}%</td>
                            </tr>
                          </tbody>
                          <tfoot v-if="logs.length > 0">
                            <tr>
                              <th colspan="12">
                                Total de Empresas:
                                {{ logs.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import { UF_REGIONS, REGIONS } from "@/api/constants";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    types: [
      {
        value: "fra",
        text: "Franquias",
      },
      {
        value: "mul",
        text: "Multimarcas",
      },
    ],
    typeCompany: [],
    regions: [],
    selectedRegions: [],
    ufs: [],
    selectedUfs: [],
    multi: 0,
    status: "1",
    statusCompany: [
      {
        value: "",
        text: "Todos",
      },
      {
        value: "1",
        text: "Ativos",
      },
      {
        value: "0",
        text: "Inativos",
      },
    ],
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    logs: [],
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
  }),
  computed: {
    allTypesSelected() {
      return this.typeCompany.length === this.types.length;
    },
    someTypesSelected() {
      return this.typeCompany.length > 0 && !this.allTypesSelected;
    },
    iconSelectTypes() {
      if (this.allTypesSelected) return "mdi-close-box";
      if (this.someTypesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allRegionsSelected() {
      return this.selectedRegions.length === this.regions.length;
    },
    someRegionsSelected() {
      return this.selectedRegions.length > 0 && !this.allRegionsSelected;
    },
    iconSelectedRegion() {
      if (this.allRegionsSelected) return "mdi-close-box";
      if (this.someRegionsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allUfsSelected() {
      return this.selectedUfs.length === this.ufs.length;
    },
    someUfsSelected() {
      return this.selectedUfs.length > 0 && !this.allUfsSelected;
    },
    iconSelectedUf() {
      if (this.allUfsSelected) return "mdi-close-box";
      if (this.someUfsSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.typeCompany = this.types.map((item) => item.value);
      this.regions = REGIONS;
      this.ufs = UF_REGIONS;

      this.selectedUfs = this.ufs.map((item) => item.value);
      this.selectedRegions = this.regions.map((item) => item.name);
      // await this.getLogs();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allTypesSelected) {
          this.typeCompany = [];
        } else {
          this.typeCompany = this.types.map((item) => item.value);
        }
      });
    },
    toggleRegion() {
      this.$nextTick(() => {
        if (this.allRegionsSelected) {
          this.selectedRegions = [];
        } else {
          this.selectedRegions = this.regions.map((item) => item.name);
        }
      });
    },
    toggleUfs() {
      this.$nextTick(() => {
        if (this.allUfsSelected) {
          this.selectedUfs = [];
        } else {
          this.selectedUfs = this.ufs.map((item) => item.value);
        }
      });
    },
    validate() {},
    async getLogs() {
      this.showAlert = false;
      this.loading = true;
      this.logs = [];
      let data = {
        status: this.status,
        types: this.typeCompany.length == 0 ? ["fra", "mul"] : this.typeCompany,
        regions: this.selectedRegions,
        ufs: this.selectedUfs,
        report: "royalties",
      };
      try {
        let response = await fetch(`${URL}report/report-company?`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        });
        let res = await response.json();
        this.logs = res;
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível carregar as Franquias, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async exportLogs(type) {
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.logs = this.logs;

      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}report/export-royalties/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}report/download-company/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
